var core = module.exports = { version: '2.7.16' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
